import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { EventBus } from "@saas/components/src/utils/event-bus";
export default {
  data() {
    return {
      selfMicVolume: 0,
      selfIsSpeaking: false,
      selfSpeakeTimer: null,
      isNeedListenVolumeChange: false,
    };
  },
  watch: {
    liveService: {
      handler(val) {
        if (val && this.isNeedListenVolumeChange) {
          this.liveService.enableAudioVolumeEvaluation();
          this.liveService.on("audioVolumnChange", this.onSelfVolumeChange);
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    clearTimeout(this.selfSpeakeTimer);
    this.liveService.off("audioVolumnChange", this.onSelfVolumeChange);
  },
  computed: {
    ...mapState("live", [
      "liveService",
      "signConfig",
      "roomInfo",
      "audioPermission",
      "videoPermission",
      "userStatus",
    ]),
    userInfo() {
      return this.$store.getters.user || {};
    },
  },
  methods: {
    ...mapMutations("live", ["setUserStatus"]),
    // 开关本地麦克风 mute true 暂停 false 开启
    handleSelfMic(mute) {
      return new Promise((resolve, reject) => {
        try {
          if (!this.audioPermission) {
            this.$darkMessage.error("打开系统权限后重试");
            reject("打开系统权限后重试");
            return;
          }
          if (!mute && this.roomInfo.isAssistant) {
            // 助教打开麦克风必须上台才能打开
            if (this.userStatus.is_up_stage !== 1) {
              this.$darkMessage.error("上台后，才能开启音视频功能");
              reject("上台后，才能开启音视频功能");
              return;
            }
          }
          if (!mute && this.roomInfo.isStudent) {
            // 如果是学生打开麦克风必须上台并且有权限
            if (this.userStatus.is_up_stage !== 1) {
              this.$darkMessage.error("上台后，才能开启音视频功能");
              reject("上台后，才能开启音视频功能");
              return;
            }
            // 开启麦克风
            if (this.userStatus.is_send_audio !== 1) {
              // 没有权限开启
              this.$darkMessage.error("您被老师禁止打开麦克风");
              reject("您被老师禁止打开麦克风");
              return;
            }
          }
          this.liveService
            .muteLocalAudio({ mute: mute })
            .then(() => {
              console.log("handleSelfMic_muteLocalAudio", mute);
              this.setUserStatus({
                audio_state: mute ? 2 : 1,
              });
              EventBus.$emit("audioMute", {
                userId: this.userStatus.user_id,
                isMute: mute,
              });
              resolve();
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          console.error("handleSelfMic", error);
          this.$darkMessage.error(mute ? "关闭麦克风失败" : "打开麦克风失败");
          reject(error);
        }
      });
    },
    // 监听自己音量变化
    onSelfVolumeChange(res) {
      // console.log("audioVolumnChange>>>self", res);
      if (res.userId === "") {
        // 自己的音量
        this.selfMicVolume = res.volume;
        if (this.selfMicVolume > 0) {
          this.selfIsSpeaking = true;
          clearTimeout(this.selfSpeakeTimer);
          this.selfSpeakeTimer = setTimeout(() => {
            this.selfIsSpeaking = false;
          }, 1000);
        }
      }
    },
    // 开关本地摄像头mute true 暂停 false 开启
    handleSelfCamera(mute, dom) {
      return new Promise((resolve, reject) => {
        try {
          if (!this.videoPermission) {
            this.$darkMessage.error("打开系统权限后重试");
            reject("打开系统权限后重试");
            return;
          }
          if (!mute && this.roomInfo.isAssistant) {
            // 助教打开摄像头必须上台才能打开
            if (this.userStatus.is_up_stage !== 1) {
              this.$darkMessage.error("上台后，才能开启音视频功能");
              reject("上台后，才能开启音视频功能");
              return;
            }
          }
          if (!mute && this.roomInfo.isStudent) {
            // 如果是学生打开摄像头必须上台并且有权限
            if (this.userStatus.is_up_stage !== 1) {
              this.$darkMessage.error("上台后，才能开启音视频功能");
              reject("上台后，才能开启音视频功能");
              return;
            }
            if (this.userStatus.is_send_video !== 1) {
              // 没有权限开启
              this.$darkMessage.error("您被老师禁止打开摄像头");
              reject("您被老师禁止打开摄像头");
              return;
            }
          }
          if (mute) {
            this.liveService
              .stopLocalPreview()
              .then(() => {
                this.setUserStatus({
                  video_state: mute ? 2 : 1,
                });
                EventBus.$emit("videoMute", {
                  userId: this.userStatus.user_id,
                  isMute: mute,
                });
                resolve();
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            this.liveService
              .startLocalPreview({
                dom: dom,
                publish: true,
              })
              .then(() => {
                console.log("handleSelfCamera_startLocalPreview");
                this.setUserStatus({
                  video_state: mute ? 2 : 1,
                });
                EventBus.$emit("videoMute", {
                  userId: this.userStatus.user_id,
                  isMute: mute,
                });
                resolve();
              })
              .catch((error) => {
                reject(error);
              });
          }
        } catch (error) {
          console.error("handleSelfCamera", error);
          this.$darkMessage.error(mute ? "关闭摄像头失败" : "打开摄像头失败");
          reject(error);
        }
      });
    },
  },
};
